


import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ApiService } from '../../api.service';
import { Router } from '@angular/router';
import { CommonService } from '../../shared/common.service';
import { FoldersDataService, Folder } from '../folders/folders-data.service';

@Component({
  selector: 'app-ecrf-list',
  templateUrl: './ecrf-list.component.html',
  styleUrls: ['./ecrf-list.component.scss']
})
export class EcrfListComponent implements OnInit {

  users: any[] = []; // backend nundi templates list
  loading: boolean = false;

  // Pagination
  currentPage: number = 1;
  limit: number = 10;
  pages: number = 1;
  pageRange: number[] = [];

  // Filters
  lockFilter: string = '';
  search1: string = '';
  search2: string = '';
  search3: string = '';

  // Filtered templates for display
  filteredTemplates: any[] = [];

  // Form
  studyForm!: FormGroup;
  isEditMode: boolean = false;
  validationMessage1: string = '';
  validationMessage2: string = '';
  validationMessage4: string = '';

  // Create Template Modal
  showCreateTemplateModal: boolean = false;
  newTemplateName: string = '';
  templateNameError: string = '';

  // Lock/Unlock Template Modal
  showLockModal: boolean = false;
  isLocking: boolean = true;
  lockEmail: string = '';
  lockPassword: string = '';
  lockError: string = '';
  showLockPassword: boolean = false;
  currentTemplate: any = null;

  // Terms and Conditions Modal
  showTermsModal: boolean = false;
  termsAccepted: boolean = false;

  // Final Confirmation Modal
  showConfirmModal: boolean = false;

  // Duplicate Template Modal
  showDuplicateModal: boolean = false;
  templateToDuplicate: any = null;
  duplicateTemplateName: string = '';
  duplicateTemplateNameError: string = '';
  duplicating: boolean = false;

  // Rename Template Modal
  showRenameModal: boolean = false;
  templateToRename: any = null;
  renameTemplateName: string = '';
  renameTemplateNameError: string = '';
  renaming: boolean = false;

  // CRC Dropdown
  ecrfTemplates: any = [];
  crcsList: any[] = [
    { id: 1, itemName: 'CRC-1' },
    { id: 2, itemName: 'CRC-2' },
    { id: 3, itemName: 'CRC-3' }
  ];

  // Default folders for template creation
  defaultFolders: Folder[] = [];
  dropdownSettings = {
    singleSelection: false,
    idField: 'id',
    textField: 'itemName',
    selectAllText: 'Select All',
    unSelectAllText: 'Unselect All',
    itemsShowLimit: 3,
    allowSearchFilter: true
  };

  // Auto-incrementing template number
  private nextTemplateNumber: number = 1;

  constructor(
    private fb: FormBuilder, 
    private apiService: ApiService,
    private router: Router,
    private commonService: CommonService,
    private foldersDataService: FoldersDataService
  ) {}

  ngOnInit(): void {
    this.studyForm = this.fb.group({
      studyName: ['', Validators.required],
      studyCode: ['', Validators.required],
      selectedCrcs: [[], Validators.required]
    });

    this.loadDefaultFolders();
    this.loadEcrfTemplates();
  }

  loadDefaultFolders() {
    this.foldersDataService.getFoldersData().subscribe(data => {
      this.defaultFolders = data.folders;
    });
  }

    loadEcrfTemplates() {

    console.log("Running Get Templates")
    this.loading = true;
    this.apiService.gettemplates().subscribe(
      response => {
        console.log(response.template);
        this.ecrfTemplates = response.template;
        
        // Assign template numbers and find next available number
        this.assignTemplateNumbers();
        
        // Sort templates so that duplicated templates appear below their originals
        this.sortTemplatesForDisplay();
        
        // Initialize filtered templates with all templates (no filtering on load)
        this.filteredTemplates = [...this.ecrfTemplates];
        
        this.loading = false;
      },
      error => {
        this.loading = false;
        console.log(error.message);
      }
    )
  }

  // Assign template numbers and find next available number
  private assignTemplateNumbers() {
    if (!this.ecrfTemplates || this.ecrfTemplates.length === 0) {
      this.nextTemplateNumber = 1;
      return;
    }

    // Sort templates by creation date to maintain chronological order
    const sortedTemplates = [...this.ecrfTemplates].sort((a, b) => {
      const dateA = new Date(a.created_on);
      const dateB = new Date(b.created_on);
      return dateA.getTime() - dateB.getTime();
    });

    // Assign template numbers starting from 1
    let templateNumber = 1;
    sortedTemplates.forEach(template => {
      if (!template.template_number) {
        template.template_number = templateNumber++;
      } else {
        // If template already has a number, update our counter
        templateNumber = Math.max(templateNumber, template.template_number + 1);
      }
    });

    // Set the next available template number
    this.nextTemplateNumber = templateNumber;
  }

  // Load users / templates (dummy for now)
  loadUsers() {
    this.loading = true;

    setTimeout(() => {
      this.users = [
        { id: 1},
        { id: 2 },
        { id: 3 }
      ];
      this.pages = Math.ceil(this.users.length / this.limit);
      this.setPageRange();
      this.loading = false;
    }, 800);
  }

  // Pagination methods
  setPageRange() {
    this.pageRange = Array.from({ length: this.pages }, (_, i) => i + 1);
  }

  prevPage() {
    if (this.currentPage > 1) {
      this.currentPage--;
    }
  }

  nextPage() {
    if (this.currentPage < this.pages) {
      this.currentPage++;
    }
  }

  goToPage(page: number) {
    this.currentPage = page;
  }

  // Search and Clear
  searchUsers() {
    console.log('Searching with filters:', this.search1, this.search2, this.search3, this.lockFilter);
    this.applyFilters();
  }

  clear() {
    this.search1 = '';
    this.search2 = '';
    this.search3 = '';
    this.lockFilter = '';
    // Show all templates when cleared
    this.filteredTemplates = [...this.ecrfTemplates];
    this.pages = Math.ceil(this.filteredTemplates.length / this.limit);
    this.setPageRange();
  }

  // Apply filters to templates
  applyFilters() {
    if (!this.ecrfTemplates) {
      this.filteredTemplates = [];
      return;
    }

    this.filteredTemplates = this.ecrfTemplates.filter(template => {
      // Filter by template name (search2)
      const nameMatch = !this.search2 || 
        template.name.toLowerCase().includes(this.search2.toLowerCase());

      // Filter by created by (search3)
      const createdByMatch = !this.search3 || 
        (template.created_by && template.created_by.toLowerCase().includes(this.search3.toLowerCase()));

      // Filter by lock status (lockFilter)
      let lockMatch = true;
      if (this.lockFilter !== '') {
        if (this.lockFilter === 'locked') {
          lockMatch = template.is_locked === true || template.is_locked === 1;
        } else if (this.lockFilter === 'unlocked') {
          lockMatch = template.is_locked === false || template.is_locked === 0;
        }
      }

      return nameMatch && createdByMatch && lockMatch;
    });

    // Update pagination
    this.pages = Math.ceil(this.filteredTemplates.length / this.limit);
    this.setPageRange();
  }

  // Modal handling
  openEditModal(template?: any) {
    this.router.navigate(['/ecrf-template', template.id]);
    // this.isEditMode = !!template;
    // if (template) {
    //   this.studyForm.patchValue({
    //     studyName: template.name,
    //     studyCode: template.id,
    //     // selectedCrcs: [this.crcsList[0]]
    //   });
    // } else {
    //   this.studyForm.reset();
    // }
    // const modal: any = document.getElementById('createStudyModal');
    // if (modal) {
    //   const modalInstance = new (window as any).bootstrap.Modal(modal);
    //   modalInstance.show();
    // }
  }

  // Form submit
  onCreate() {
    if (this.studyForm.invalid) {
      this.validationMessage1 = this.studyForm.get('studyName')?.hasError('required') ? 'Study Name is required' : '';
      this.validationMessage2 = this.studyForm.get('studyCode')?.hasError('required') ? 'Study Code is required' : '';
      this.validationMessage4 = this.studyForm.get('selectedCrcs')?.value.length === 0 ? 'Select at least one CRC' : '';
      return;
    }

    if (this.isEditMode) {
      console.log('Updating study:', this.studyForm.value);
    } else {
      console.log('Creating new study:', this.studyForm.value);
    }

    const modal: any = document.getElementById('createStudyModal');
    if (modal) {
      const modalInstance = (window as any).bootstrap.Modal.getInstance(modal);
      modalInstance.hide();
    }
  }

  // Create Template Modal Methods
  openCreateTemplateModal() {
    this.showCreateTemplateModal = true;
    this.newTemplateName = '';
    this.templateNameError = '';
  }

  closeCreateTemplateModal() {
    this.showCreateTemplateModal = false;
    this.newTemplateName = '';
    this.templateNameError = '';
  }

  createTemplate() {
    if (!this.newTemplateName.trim()) {
      this.templateNameError = 'Template name is required';
      return;
    }

    if (this.newTemplateName.trim().length > 100) {
      this.templateNameError = 'Template name must be less than 100 characters';
      return;
    }

    // Check if template name contains only valid characters
    const validNameRegex = /^[a-zA-Z0-9\s\-_\.\/]+$/;
    if (!validNameRegex.test(this.newTemplateName.trim())) {
      this.templateNameError = 'Template name can only contain letters, numbers, spaces, hyphens, underscores, dots, and slashes (/).';
      return;
    }

    // Check if template name already exists
    const trimmedName = this.newTemplateName.trim();
    const existingTemplate = this.ecrfTemplates.find(template => 
      template.name.toLowerCase() === trimmedName.toLowerCase()
    );
    if (existingTemplate) {
      this.templateNameError = 'A template with this name already exists';
      return;
    }

    this.templateNameError = '';
    this.loading = true;

    // Get current user data
    const userData = this.commonService.getUserData();
    console.log('User data:', userData);
    
    // Create template object
    const newTemplate = {
      name: this.newTemplateName.trim(),
      created_by: userData ? userData.id || 'System' : 'Unknown User',
      created_on: new Date().toISOString().split('T')[0], // Current date in YYYY-MM-DD format
      is_active: true,
      is_locked: false,
      template_number: this.nextTemplateNumber, // Assign the next template number
      folders: this.convertDefaultFoldersToTemplate()
    };

    console.log('Sending template data:', newTemplate);

    // Call API to create template
    this.apiService.saveTemplates(newTemplate).subscribe(
      response => {
        console.log('Template created successfully:', response);
        this.loading = false;
        this.closeCreateTemplateModal();
        this.loadEcrfTemplates(); // Reload the templates list
      },
      error => {
        console.error('Error creating template:', error);
        this.loading = false;
        
        // Provide more specific error messages
        if (error.status === 401) {
          this.templateNameError = 'Authentication failed. Please login again.';
        } else if (error.status === 400) {
          // Extract error message from response
          let errorMessage = 'Invalid template data. Please check the template name.';
          if (error.error) {
            if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          }
          // Show alert with the error message from response
          alert(errorMessage);
          this.templateNameError = errorMessage;
        } else if (error.status === 500) {
          this.templateNameError = 'Server error. Please try again later.';
        } else {
          this.templateNameError = `Failed to create template: ${error.message || 'Unknown error'}`;
        }
      }
    );
  }

  // Lock/Unlock Template Methods
  lockTemplate(template: any) {
    this.isLocking = true;
    this.currentTemplate = template;
    this.termsAccepted = false;
    this.showTermsModal = true;
  }


  // Terms and Conditions Methods
  closeTermsModal() {
    this.showTermsModal = false;
    this.termsAccepted = false;
    this.currentTemplate = null;
  }

  acceptTerms() {
    if (this.termsAccepted) {
      this.showTermsModal = false;
      this.showConfirmModal = true;
    }
  }

  // Final Confirmation Methods
  closeConfirmModal() {
    this.showConfirmModal = false;
    this.currentTemplate = null;
  }

  confirmLock() {
    this.showConfirmModal = false;
    this.showLockModal = true;
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockError = '';
  }

  closeLockModal() {
    this.showLockModal = false;
    this.lockEmail = '';
    this.lockPassword = '';
    this.lockError = '';
    this.currentTemplate = null;
  }

  toggleLockPasswordVisibility() {
    this.showLockPassword = !this.showLockPassword;
  }

  authenticateAndLock() {
    if (!this.lockEmail || !this.lockPassword) {
      this.lockError = 'Please enter both email and password';
      return;
    }

    this.lockError = '';
    this.loading = true;

    const purpose = 'lock_template'
    // Authenticate using the same login API
    this.apiService.login(this.lockEmail, this.lockPassword, purpose).subscribe(
      response => {
        // Authentication successful, now lock/unlock the template
        this.updateTemplateLockStatus();
      },
      error => {
        this.loading = false;
        this.lockError = 'Invalid email or password. Please try again.';
        console.error('Authentication error:', error);
      }
    );
  }

  updateTemplateLockStatus() {
    if (!this.currentTemplate) {
      this.loading = false;
      return;
    }

    // Create updated template object with lock status (always lock)
    const updatedTemplate = {
      ...this.currentTemplate,
      is_locked: true
    };

    console.log('Updating template with data:', updatedTemplate);

    const updateData = {
      templateId: this.currentTemplate.id,
      isLocked: true
    }

    this.apiService.updateTemplateLockStatus(updateData).subscribe(
      response => {
        this.ecrfTemplates.find(template => template.id === this.currentTemplate.id).is_locked = true;
        this.loading = false;
        this.closeLockModal();
      },
      error => {
        console.error('Error updating template lock status:', error);
        this.loading = false;
        // Extract error message from response
        let errorMessage = 'Failed to update template lock status. Please try again.';
        if (error.error) {
          if (error.error.message) {
            errorMessage = error.error.message;
          } else if (error.error.error) {
            errorMessage = error.error.error;
          } else if (typeof error.error === 'string') {
            errorMessage = error.error;
          }
        }
        // Show alert with the error message from backend
        alert(errorMessage);
        this.lockError = errorMessage;
        this.closeLockModal();
      }
    )
  }

  // Template Actions
  deleteTemplate(id: number) {
    if (confirm('Are you sure you want to delete this template? This action cannot be undone.')) {
      this.loading = true;
      this.apiService.deleteTemplate(String(id)).subscribe(
        response => {
          console.log('Template deleted successfully:', response);
          this.loading = false;
          this.loadEcrfTemplates(); // Reload the templates list
        },
        error => {
          console.error('Error deleting template:', error);
          this.loading = false;
          alert('Failed to delete template. Please try again.');
        }
      );
    }
  }

  // Duplicate Template Methods
  duplicateTemplate(template: any) {
    this.templateToDuplicate = template;
    this.duplicateTemplateName = template.name + ' (Copy)';
    this.duplicateTemplateNameError = '';
    this.showDuplicateModal = true;
  }

  closeDuplicateModal() {
    this.showDuplicateModal = false;
    this.templateToDuplicate = null;
    this.duplicateTemplateName = '';
    this.duplicateTemplateNameError = '';
    this.duplicating = false;
  }

  confirmDuplicateTemplate() {
    if (!this.duplicateTemplateName.trim()) {
      this.duplicateTemplateNameError = 'Template name is required';
      return;
    }

    if (this.duplicateTemplateName.trim().length > 100) {
      this.duplicateTemplateNameError = 'Template name must be less than 100 characters';
      return;
    }

    // Check if template name contains only valid characters
    const validNameRegex = /^[a-zA-Z0-9\s\-_\.\/]+$/;
    if (!validNameRegex.test(this.duplicateTemplateName.trim())) {
      this.duplicateTemplateNameError = 'Template name can only contain letters, numbers, spaces, hyphens, underscores, dots, and slashes (/).';
      return;
    }

    // Check if template name already exists
    const trimmedName = this.duplicateTemplateName.trim();
    const existingTemplate = this.ecrfTemplates.find(template => 
      template.name.toLowerCase() === trimmedName.toLowerCase()
    );
    if (existingTemplate) {
      this.duplicateTemplateNameError = 'A template with this name already exists';
      return;
    }

    this.duplicateTemplateNameError = '';
    this.duplicating = true;

    // First, get the full template data with folders, forms, and fields
    this.apiService.getTemplateData(this.templateToDuplicate.id.toString()).subscribe(
      (templateResponse) => {
        console.log('Template data retrieved for duplication:', templateResponse);
        
        if (templateResponse.template) {
          this.createDuplicateTemplate(templateResponse.template);
        } else {
          this.duplicateTemplateNameError = 'Failed to retrieve template data for duplication';
          this.duplicating = false;
        }
      },
      (error) => {
        console.error('Error retrieving template data for duplication:', error);
        this.duplicateTemplateNameError = 'Failed to retrieve template data for duplication';
        this.duplicating = false;
      }
    );
  }

  private createDuplicateTemplate(originalTemplate: any) {
    // Get current user data
    const userData = this.commonService.getUserData();
    // const creator = userData ? userData.first_name + ' ' + userData.last_name : 'System';
    
    // Create deep copy of the template with new IDs and names
    const duplicatedTemplate = this.deepCloneTemplate(originalTemplate);
    
    // Update template metadata
    duplicatedTemplate.name = this.duplicateTemplateName.trim();
    duplicatedTemplate.created_by = userData.id;
    duplicatedTemplate.created_on = new Date().toISOString().split('T')[0];
    duplicatedTemplate.is_active = true;
    duplicatedTemplate.is_locked = false;
    duplicatedTemplate.template_number = this.nextTemplateNumber; // Assign the next template number
    
    console.log('Creating duplicated template:', duplicatedTemplate);

    // Save the duplicated template
    this.apiService.saveTemplates(duplicatedTemplate).subscribe(
      response => {
        console.log('Template duplicated successfully:', response);
        this.duplicating = false;
        this.closeDuplicateModal();
        this.loadEcrfTemplates(); // Reload the templates list
      },
      error => {
        console.error('Error duplicating template:', error);
        this.duplicating = false;
        
        // Provide more specific error messages
        if (error.status === 401) {
          this.duplicateTemplateNameError = 'Authentication failed. Please login again.';
        } else if (error.status === 400) {
          // Extract error message from response
          let errorMessage = 'Invalid template data. Please check the template name.';
          if (error.error) {
            if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          }
          // Show alert with the error message from response
          alert(errorMessage);
          this.duplicateTemplateNameError = errorMessage;
        } else if (error.status === 500) {
          this.duplicateTemplateNameError = 'Server error. Please try again later.';
        } else {
          this.duplicateTemplateNameError = `Failed to duplicate template: ${error.message || 'Unknown error'}`;
        }
      }
    );
  }

  private deepCloneTemplate(template: any): any {
    // Create a deep copy of the template with new IDs for folders, forms, and fields
    const clonedTemplate = JSON.parse(JSON.stringify(template));
    
    // Generate new template ID
    clonedTemplate.id = Date.now() + Math.random();
    
    // Mark as duplicate template
    clonedTemplate.is_duplicate = true;
    clonedTemplate.original_template_id = template.id;
    
    // Clone folders with new IDs
    if (clonedTemplate.folders) {
      clonedTemplate.folders = clonedTemplate.folders.map((folder: any) => {
        const clonedFolder = { ...folder };
        clonedFolder.id = Date.now() + Math.random();
        
        // Clone forms with new IDs
        if (clonedFolder.forms) {
          clonedFolder.forms = clonedFolder.forms.map((form: any) => {
            const clonedForm = { ...form };
            clonedForm.id = Date.now() + Math.random();
            
            // Clone fields with new IDs
            if (clonedForm.fields) {
              clonedForm.fields = clonedForm.fields.map((field: any) => {
                const clonedField = { ...field };
                // Generate new field name to avoid conflicts
                clonedField.name = field.name + '_' + Date.now();
                return clonedField;
              });
            }
            
            return clonedForm;
          });
        }
        
        return clonedFolder;
      });
    }
    
    return clonedTemplate;
  }

  private sortTemplatesForDisplay() {
    // Sort templates by template number (auto-incrementing sequence)
    this.ecrfTemplates.sort((a: any, b: any) => {
      // If both have template numbers, sort by template number
      if (a.template_number && b.template_number) {
        return a.template_number - b.template_number;
      }
      
      // If only one has a template number, put it first
      if (a.template_number && !b.template_number) {
        return -1;
      }
      
      if (!a.template_number && b.template_number) {
        return 1;
      }
      
      // If neither has template number, sort by creation date
      const dateA = new Date(a.created_on);
      const dateB = new Date(b.created_on);
      return dateA.getTime() - dateB.getTime();
    });
  }

  // Rename Template Methods
  renameTemplate(template: any) {
    this.templateToRename = template;
    this.renameTemplateName = template.name;
    this.renameTemplateNameError = '';
    this.showRenameModal = true;
  }

  closeRenameModal() {
    this.showRenameModal = false;
    this.templateToRename = null;
    this.renameTemplateName = '';
    this.renameTemplateNameError = '';
    this.renaming = false;
  }

  confirmRenameTemplate() {
    if (!this.renameTemplateName.trim()) {
      this.renameTemplateNameError = 'Template name is required';
      return;
    }

    if (this.renameTemplateName.trim().length > 100) {
      this.renameTemplateNameError = 'Template name must be less than 100 characters';
      return;
    }

    // Check if template name contains only valid characters
    const validNameRegex = /^[a-zA-Z0-9\s\-_\.\/]+$/;
    if (!validNameRegex.test(this.renameTemplateName.trim())) {
      this.renameTemplateNameError = 'Template name can only contain letters, numbers, spaces, hyphens, underscores, dots, and slashes (/).';
      return;
    }

    // Check if template name already exists (excluding current template)
    const trimmedName = this.renameTemplateName.trim();
    const existingTemplate = this.ecrfTemplates.find(template => 
      template.id !== this.templateToRename.id && 
      template.name.toLowerCase() === trimmedName.toLowerCase()
    );
    if (existingTemplate) {
      this.renameTemplateNameError = 'A template with this name already exists';
      return;
    }

    this.renameTemplateNameError = '';
    this.renaming = true;

    // Create updated template object with new name
    const updatedTemplate = {
      ...this.templateToRename,
      name: this.renameTemplateName.trim()
    };

    console.log('Renaming template with data:', updatedTemplate);

    // Use the existing saveTemplates API to update the template
    this.apiService.saveTemplates(updatedTemplate).subscribe(
      response => {
        console.log('Template renamed successfully:', response);
        this.renaming = false;
        this.closeRenameModal();
        this.loadEcrfTemplates(); // Reload the templates list
      },
      error => {
        console.error('Error renaming template:', error);
        this.renaming = false;
        
        // Provide more specific error messages
        if (error.status === 401) {
          this.renameTemplateNameError = 'Authentication failed. Please login again.';
        } else if (error.status === 400) {
          // Extract error message from response
          let errorMessage = 'Invalid template data. Please check the template name.';
          if (error.error) {
            if (error.error.message) {
              errorMessage = error.error.message;
            } else if (error.error.error) {
              errorMessage = error.error.error;
            } else if (typeof error.error === 'string') {
              errorMessage = error.error;
            }
          }
          // Show alert with the error message from response
          alert(errorMessage);
          this.renameTemplateNameError = errorMessage;
        } else if (error.status === 404) {
          this.renameTemplateNameError = 'Template not found. Please refresh and try again.';
        } else if (error.status === 500) {
          this.renameTemplateNameError = 'Server error. Please try again later.';
        } else {
          this.renameTemplateNameError = `Failed to rename template: ${error.message || 'Unknown error'}`;
        }
      }
    );
  }

  // Template structure conversion methods (similar to build-ecrf component)
  convertDefaultFoldersToTemplate(): any[] {
    return this.defaultFolders.map(defaultFolder => ({
      id: Date.now() + Math.random(), // Generate unique ID
      name: defaultFolder.name,
      icon: defaultFolder.icon,
      color: defaultFolder.color,
      description: defaultFolder.description,
      title: defaultFolder.title,
      subTitle: defaultFolder.subTitle,
      createdAt: new Date().toISOString(),
      forms: defaultFolder.forms.map(defaultForm => ({
        id: Date.now() + Math.random().toString(36).substring(2,5), // Generate unique ID
        name: defaultForm.name,
        route: defaultForm.route,
        createdAt: new Date().toISOString(),
        fields: defaultForm.fields.map(defaultField => this.convertDefaultFieldToTemplate(defaultField))
      }))
    }));
  }

  convertDefaultFieldToTemplate(defaultField: any): any {
    const fieldName = defaultField.title.toLowerCase().replace(/\s+/g, '_');
    
    let convertedField: any = {
      title: defaultField.title,
      name: fieldName,
      type: this.mapFieldType(defaultField.type),
      required: defaultField.required,
      description: defaultField.description,
      attachmentRequired: false
    };

    if(defaultField.hasDependency){
      convertedField.hasDependency = true;
      convertedField.dependencyFieldName = defaultField.dependencyFieldName;
    }
    // Handle field-specific properties
    if (defaultField.values && defaultField.values.length > 0) {
      convertedField.options = defaultField.values.map((v: any) => v.label);
    }

    if (defaultField.columns && defaultField.columns.length > 0) {
      convertedField.columns = defaultField.columns;
    }

    if (defaultField.unit) {
      convertedField.unit = defaultField.unit;
    }

    // Handle compound fields
    if (defaultField.fields && defaultField.fields.length > 0) {
      convertedField.subFields = defaultField.fields.map((subField: any) => this.convertDefaultFieldToTemplate(subField));
    }

    return convertedField;
  }

  mapFieldType(defaultType: string): string {
    const typeMapping: { [key: string]: string } = {
      'radio-button': 'radio',
      'dropdown': 'select',
      'date': 'date',
      'time': 'time',
      'number': 'number',
      'textarea': 'textarea',
      'checkbox-group': 'checkbox',
      'calculated': 'calculated',
      'compound': 'compound',
      'signature': 'esignature',
      'table': 'table',
      'title': 'title'
    };

    return typeMapping[defaultType] || 'text';
  }
}
